var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 마이 아이템 리스트 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }